import { Button, Heading, HFlow, VFlow } from 'bold-ui'
import theme from 'config/theme'
import React, { useState } from 'react'

import { ModalUnificarBases } from './ModalUnificarBases'

export const UnificarBasesChaveValidada = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>()
  const handleMostrarModal = () => {
    setIsModalOpen(true)
  }
  return (
    <HFlow
      alignItems='flex-start'
      style={{
        border: `1px solid ${theme.pallete.divider}`,
        padding: '1rem',
      }}
    >
      <VFlow>
        <Heading level={3}>Chave validada com sucesso</Heading>
        <p>
          Ao unificar a sua base com a instalação do destinatário, seu sistema será desativado e o novo link de acesso
          esus APS será repassado pelo administrador da instalação destino.
        </p>
      </VFlow>

      <Button size='small' kind='danger' onClick={handleMostrarModal}>
        Unificar bases
      </Button>

      <ModalUnificarBases isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </HFlow>
  )
}
